<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['展商活动']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="3">
            <el-input v-model.trim="title" placeholder="请输入标题" clearable size="small"></el-input>
          </el-col>
          <!--          <el-col :span="3">-->
          <!--            <el-select v-model="activityType" style="width: 100%" placeholder="请选择类型" clearable>-->
          <!--              <el-option-->
          <!--                  v-for="item in activityTypeList"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value"-->
          <!--              >-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-col>-->
          <el-col :span="6">
            <el-date-picker style="width: 100%;" v-model="statisticalDate" type="datetimerange" size="small"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" @change="getTime">
            </el-date-picker>
          </el-col>
          <el-col :span="4">
            <el-select clearable v-model="status" placeholder="请选择状态" style="width: 100%;" size="small">
              <el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button @click="getPageList" class="btn-search" round icon="el-icon-search" size="small">查询
            </el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置
            </el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-button class="btns-add" icon="el-icon-plus" size="small" @click="add" v-if="hasPerm('businessman-add')">添加
          </el-button>
          <el-button :disabled="selectData.length === 0" type="primary" icon="el-icon-edit-outlin" size="small"
                     @click="verifyMore" v-if="hasPerm('businessman-batch-verify')">批量审核</el-button>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" class="flex-1" stripe height="100%" style="width: 100%" border
            @selection-change="selectRow">
            <el-table-column type="selection" width="80px" align="center" fixed></el-table-column>
            <el-table-column prop="title" align="center" label="标题" show-overflow-tooltip width="160"></el-table-column>
            <el-table-column prop="listCover" align="center" label="列表封面图" show-overflow-tooltip width="160">
              <template slot-scope="scope">
                <el-image v-if="scope.row.cover" style="width: auto;height: 20px" :src="scope.row.cover"
                  :preview-src-list="[scope.row.cover]" fit="contain"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="startDate" align="center" label="开始时间" show-overflow-tooltip width="180"></el-table-column>
            <el-table-column prop="endDate" align="center" label="结束时间" show-overflow-tooltip width="180"></el-table-column>
            <el-table-column prop="address" align="center" label="活动地点" show-overflow-tooltip width="160"></el-table-column>
            <el-table-column prop="status" align="center" show-overflow-tooltip label="状态" width="160">
              <template slot-scope="scope">
                <span v-if="scope.row.status === '2'">通过</span>
                <span v-else-if="scope.row.status === '3'" class="reject-btns"
                  @click="checkRejectReason(scope.row.reason)">查看驳回原因</span>
                <span v-else>待审核</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="240" fixed="right">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button type="text" size="mini" @click="edit(scope.row.id)"
                    v-if="hasPerm('businessman-edit')">编辑
                  </el-button>
                  <el-button icon="el-icon-document-checked" type="text"
                    @click="verify(scope.row.id, scope.row.status, scope.row.reason)" size="mini"
                    v-if="hasPerm('businessman-verify')">审核</el-button>
                  <el-button size="mini" type="text" @click="handleDelete(scope.row.id)"
                    v-if="hasPerm('businessman-delete')">删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes"
            :total="total">
          </el-pagination>
        </el-row>
      </el-card>
    </div>

    <el-dialog title="审核" :visible.sync="dialogShow">
      <el-form width="30%" ref="verifyForm" :model="verifyForm" class="add-form" :rules="verifyRules">
        <el-form-item label="审核状态" label-width="120px" prop="status">
          <el-radio-group v-model="verifyForm.status" @change="verifySelect">
            <el-radio label="2">通过</el-radio>
            <el-radio label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核原因" prop="reason" label-width="120px" v-if="verifyForm.status === '3'">
          <div style="display: flex; flex-direction: column">
            <!--            <el-checkbox-group v-model="checkList" @change="checkChange">-->
            <!--              <el-checkbox v-for="(item, index) of selectCheckList" :label="item.reason" :key="index"></el-checkbox>-->
            <!--            </el-checkbox-group>-->
            <el-input type="textarea" :rows="4" placeholder="请输入原因" v-model.trim="verifyForm.reason">
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../../components/navHeader'

export default {
  name: 'index',
  data () {
    return {
      exportLoading: false,
      type: '',
      title: '',
      activityType: '',
      statisticalDate: '',
      startDate: '',
      endDate: '',
      companyName: '',
      status: '',
      tableData: [],
      tableHeight: 0,
      selectData: [],
      statuses: [
        {
          label: '待审核',
          value: '1'
        },
        {
          label: '通过',
          value: '2'
        },
        {
          label: '驳回',
          value: '3'
        }
      ],
      activityTypeList: [
        {
          label: '日化',
          value: '1'
        },
        {
          label: '供应链',
          value: '2'
        },
        {
          label: '专业美容',
          value: '3'
        },
        {
          label: '推荐品牌',
          value: '4'
        }
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogShow: false,
      verifyType: '',
      verifySrc: '',
      verifyStatus: '',
      reason: '',
      verifyForm: {
        status: '2',
        reason: ''
      },
      verifyRules: {
        status: {
          required: true,
          message: '请选择状态!',
          trigger: 'change'
        },
        reason: {
          required: true,
          message: '请输入原因',
          trigger: 'blur'
        }
      }
    }
  },
  components: {
    navHeader
  },
  // beforeRouteLeave (to, from, next) {
  //   if (to.name === 'ThematicDetail') {
  //     sessionStorage.setItem('currentPage', this.currentPage)
  //     sessionStorage.setItem('pageSize', this.pageSize)
  //     sessionStorage.setItem('title', this.title)
  //     sessionStorage.setItem('type', this.type)
  //   } else {
  //     sessionStorage.removeItem('currentPage')
  //     sessionStorage.removeItem('pageSize')
  //     sessionStorage.removeItem('title')
  //     sessionStorage.removeItem('type')
  //   }
  //   next()
  // },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 360
    // if (sessionStorage.getItem('currentPage')) this.currentPage = Number(sessionStorage.getItem('currentPage'))
    // if (sessionStorage.getItem('pageSize')) this.pageSize = Number(sessionStorage.getItem('pageSize'))
    // if (sessionStorage.getItem('title')) this.title = sessionStorage.getItem('title')
    // if (sessionStorage.getItem('type')) this.type = sessionStorage.getItem('type')
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let { data: res } = await this.$http.post('/exhibitionActivity/getPageList', {
        title: this.title,
        activityType: this.activityType,
        startDate: this.startDate,
        endDate: this.endDate,
        companyName: this.companyName,
        status: this.status,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    reset () {
      this.title = ''
      this.type = '2'
      this.activityType = ''
      this.statisticalDate = ''
      this.startDate = ''
      this.endDate = ''
      this.companyName = ''
      this.status = ''
      this.getPageList()
    },
    getTime (val) {
      if (val) {
        this.startDate = val[0]
        this.endDate = val[1]
      } else {
        this.startDate = ''
        this.endDate = ''
      }
    },
    add () {
      this.$router.push('businessmanActivityDetail')
    },
    edit (id) {
      this.$router.push({
        name: 'BusinessmanActivityDetail',
        params: {
          id,
          type: 'edit'
        }
      })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    selectRow (selection) {
      this.selectData = selection
    },
    verifyMore () {
      this.checkList = []
      this.dialogShow = true
      this.verifyType = '2'
      // this.verifySrc = '/cosmeticBrand/cosmeticBrand/examine'
    },
    verify (id, status, reason) {
      this.checkList = []
      this.verifyType = '1'
      this.dialogShow = true
      this.id = id
      this.verifyForm.status = status
      this.verifyForm.reason = reason
    },
    verifySelect () {
      this.verifyForm.reason = ''
    },
    confirm () {
      this.$refs.verifyForm.validate((val) => {
        if (val) {
          let ids = ''
          if (this.verifyType === '1') {
            ids = this.id
          } else {
            ids = this.selectData
              .map((item) => {
                return item.id
              })
              .join(',')
          }
          if (this.verifyForm.status !== '3') {
            this.verifyForm.reason = ''
          }
          let sumbitObj = {
            ids,
            ...this.verifyForm
          }
          this.$http
            .post('/exhibitionActivity/audit', sumbitObj)
            .then((res) => {
              if (res.data.code === '200') {
                this.$message.success('审核成功!')
                this.verifyForm = {
                  status: '',
                  reason: ''
                }
                this.getPageList()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '审核失败'
              })
            })
          this.dialogShow = false
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        status: '',
        reason: ''
      }
    },
    checkRejectReason (reason) {
      this.$alert(reason, '驳回原因', {
        confirmButtonText: '确定'
      })
    },
    handleDelete (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/exhibitionActivity/delete', { id }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    exportAll () {
      this.$confirm(`确认导出数据?`, '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.exportLoading = true
        let params = {
          title: this.title,
          status: this.status,
          type: this.type
        }
        this.$http.post('/exhibitionActivity/exportData', params, { responseType: 'blob' }).then(res => {
          console.log(res)
          const link = document.createElement('a')
          let blob = new Blob([res.data], { type: 'application/x-excel' })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = '导出专题活动数据.xlsx'
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
          this.$message.success('导出成功')
          this.exportLoading = false
        }).catch(() => {
          this.exportLoading = false
          this.$message.success('导出失败')
        })
      }).catch(() => {
        this.exportLoading = false
        this.$message.info('取消导出')
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/exhibitionManage/businessmanActivity/index.vue